export const HOSTED_PROJECT_ROOT_UPLOAD_MESSAGE = "Choose a project folder, not a filesystem root."

const IGNORED_HOSTED_UPLOAD_DIRECTORIES = new Set([
  ".git",
  ".cache",
  ".next",
  ".turbo",
  ".venv",
  "__pycache__",
  "build",
  "dist",
  "node_modules",
  "target",
  "vendor",
])

const FILESYSTEM_ROOT_SEGMENTS = new Set([
  "Applications",
  "Library",
  "System",
  "Users",
  "Volumes",
  "bin",
  "boot",
  "dev",
  "etc",
  "home",
  "opt",
  "private",
  "proc",
  "root",
  "run",
  "sbin",
  "tmp",
  "usr",
  "var",
])

function pathSegments(path: string) {
  return path.replace(/\\/g, "/").split("/").filter(Boolean)
}

function isSensitiveUploadFileName(name: string) {
  const normalized = name.toLowerCase()
  return (
    normalized === ".env" ||
    normalized.startsWith(".env.") ||
    normalized.endsWith(".pem") ||
    normalized.endsWith(".key") ||
    normalized.endsWith(".p12") ||
    normalized.endsWith(".pfx")
  )
}

function openAnalystSegmentIndex(segments: string[]) {
  return segments.findIndex((segment) => segment === ".openanalyst")
}

function hasIgnoredDirectory(segments: string[]) {
  return segments.some((segment) => IGNORED_HOSTED_UPLOAD_DIRECTORIES.has(segment))
}

export function isRootLikeHostedDirectoryName(name: string) {
  const normalized = name.trim()
  return !normalized || normalized === "/" || normalized === "\\" || /^[A-Za-z]:\\?$/.test(normalized) || normalized === "Macintosh HD"
}

export function isRootShapedHostedUpload(paths: string[]) {
  const roots = new Set(paths.map((path) => path.split("/")[0]).filter((item): item is string => !!item))
  return roots.size > 1 && [...roots].some((root) => FILESYSTEM_ROOT_SEGMENTS.has(root) || /^[A-Za-z]:$/.test(root))
}

export function shouldDescendHostedProjectDirectoryPath(path: string) {
  const segments = pathSegments(path)
  if (hasIgnoredDirectory(segments)) return false
  const openAnalystIndex = openAnalystSegmentIndex(segments)
  if (openAnalystIndex < 0) return true
  return segments.length === openAnalystIndex + 1 || segments[openAnalystIndex + 1] === "plugins"
}

export function shouldUploadHostedProjectFilePath(path: string) {
  const segments = pathSegments(path)
  const fileName = segments.at(-1)
  if (!fileName || isSensitiveUploadFileName(fileName) || hasIgnoredDirectory(segments)) return false
  const openAnalystIndex = openAnalystSegmentIndex(segments)
  if (openAnalystIndex < 0) return true
  return segments[openAnalystIndex + 1] === "plugins" && segments.length > openAnalystIndex + 3
}
